import { getLocaleFlagIcon } from '@/helpers/cdn';
import { Locale, LocaleToISO } from '@/helpers/languages';
import useEstonia from '@/hooks/estonia';

export interface Language {
  icon: string;
  name: string;
  value: string;
  isHidden?: boolean;
}

export const useLanguages = (): Language[] => {
  const { isEstonia } = useEstonia();
  return [
    {
      name: 'AU',
      icon: getLocaleFlagIcon(Locale.ENGLISH_AUSTRALIA),
      value: Locale.ENGLISH_AUSTRALIA,
    },
    {
      name: 'CA',
      icon: getLocaleFlagIcon(Locale.ENGLISH_CANADA),
      value: Locale.ENGLISH_CANADA,
    },
    {
      name: 'DE',
      icon: getLocaleFlagIcon(Locale.GERMAN),
      value: Locale.GERMAN,
    },
    {
      name: 'EE',
      icon: getLocaleFlagIcon(LocaleToISO[Locale.ESTONIA]),
      value: Locale.ESTONIA,
      isHidden: !isEstonia,
    },
    {
      name: 'FI',
      icon: getLocaleFlagIcon(Locale.FINLAND),
      value: Locale.FINLAND,
      isHidden: !isEstonia,
    },
    {
      name: 'EN',
      icon: getLocaleFlagIcon(Locale.ENGLISH),
      value: Locale.ENGLISH,
    },
    {
      name: 'FR-CA',
      icon: getLocaleFlagIcon(Locale.FRENCH_CANADA),
      value: Locale.FRENCH_CANADA,
    },
    {
      name: 'FR-CH',
      icon: getLocaleFlagIcon(Locale.FRENCH_SWITZERLAND),
      value: Locale.FRENCH_SWITZERLAND,
    },
    {
      name: 'IE',
      icon: getLocaleFlagIcon(Locale.ENGLISH_IRELAND),
      value: Locale.ENGLISH_IRELAND,
    },
    {
      name: 'NO',
      icon: getLocaleFlagIcon(Locale.NORWEGIAN),
      value: Locale.NORWEGIAN,
    },
    {
      name: 'NZ',
      icon: getLocaleFlagIcon(Locale.ENGLISH_NEW_ZEALAND),
      value: Locale.ENGLISH_NEW_ZEALAND,
    },
  ];
};
